var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.EntityCardMixin_CopySource)?_c('base-card',{attrs:{"no-padding":"","title":_vm.EntityCardMixin_Title}},[_c('base-list-overview',{attrs:{"controller":"Child","filter":_vm.filter,"hide-filter":"","inside-card":"","readonly":"","redirect":"","visible":_vm.visible}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }